import { useAuthContext } from 'components/auth';
import { BILLING_METHODS } from 'lib/constants';
import _ from 'lodash';
import { ReactNode } from 'react';
import { AdminContext } from './context';

interface IAdminContextProviderProps {
  children: ReactNode;
}

export const AdminContextProvider = ({
  children,
}: IAdminContextProviderProps) => {
  const { session } = useAuthContext();

  // Billing method utilities.
  const isCreditCardCompany =
    session.company.billingMethod === BILLING_METHODS.CREDIT_CARD;
  const isFreemiumCompany =
    session.company.billingMethod === BILLING_METHODS.FREE;
  const isInvoiceCompany =
    session.company.billingMethod === BILLING_METHODS.INVOICE;
  const isSelfServeAnnualCompany =
    isCreditCardCompany && !_.isEmpty(session.products);

  return (
    <AdminContext.Provider
      value={{
        isCreditCardCompany,
        isFreemiumCompany,
        isInvoiceCompany,
        isSelfServeAnnualCompany,
      }}
    >
      {children}
    </AdminContext.Provider>
  );
};
